import { useMutation } from "@tanstack/react-query";
import api from "apis";

export const useUpdatePushNotification = () => {
  return useMutation({
    mutationFn: api.pushNotification.updatePushNotification,
  });
};

export const useUpdatePushNotifications = () => {
  return useMutation({
    mutationFn: api.pushNotification.updatePushNotifications,
  });
};
